export default "__VITE_ASSET__SiYo0TNw__"